(function () {
  'use strict';

  angular.module('ringbaPortal').component('settingOverrideToggle', {
    bindings: {
      override: '<',
      type: '<',
      onSettingChange: '&'
    },
    controller: SettingOverrideToggleController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/select-target/setting-override-toggle.view.html'
  });

  function SettingOverrideToggleController() {
    'ngInject';

    const vm = this;
    vm.toggleChange = toggleChange;
    vm.$onChanges = onChanges;

    function onChanges(changesObj) {
      if (changesObj && changesObj.override ) {
        _setResult(changesObj.override.currentValue);
      }
    }


    function toggleChange(val) {
      if (val === 'off') {
        vm.onSettingChange({ type: vm.type, campaign: false, global: false });
      }
      if (val === 'global') {
        vm.onSettingChange({ type: vm.type, campaign: false, global: true });
      }
      if (val === 'campaign') {

        vm.onSettingChange({ type: vm.type, campaign: true, global: false });
      }
      _setResult(vm.override);
    }

    function _setResult(or) {
      vm.off = !or || (!or.campaignOverride && !or.globalOverride);
      vm.campaign = !vm.off && or.campaignOverride;
      vm.global = !vm.off && or.globalOverride;
    }

  }
})();
